import { PrintableDocument } from "@redotech/redo-model/fulfillments/print-job";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const markAsPrinted = {
  name: "markAsPrinted" as const,
  input: z.object({
    document: createEnum(PrintableDocument),
    unprint: z.boolean().nullish(),
    groups: z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
  }),
  output: z.object({}),
};
